export default "__VITE_ASSET__CzXCCh6Q__"